"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergeRefs = void 0;
var react_1 = require("react");
//TODO: Move in powerhooks
function useMergeRefs(refs) {
    return react_1.useCallback(function (value) {
        refs.forEach(function (ref) {
            if (typeof ref === "function") {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
    }, refs.map(function (ref) { return ref !== null && ref !== void 0 ? ref : Object; }));
}
exports.useMergeRefs = useMergeRefs;
//# sourceMappingURL=useMergeRefs.js.map